import { Box, Container, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import Header from "../../Components/Layout/Header";
import styles from "./Blogs.module.css";
import SearchIcon from "@mui/icons-material/Search";
import BlogTab from "../../Components/Tabs/BlogTab";
import Parse from "../../API/ParseServer";
import Footer from "../../Components/Layout/Footer";
import ScrollTopButton2 from "../../Components/Layout/ScrollToTopButton2";

const Blogs = () => {
  const [searchPhrase, setSearchPhrase] = useState("");

  let timer: number | undefined,
    timeoutVal = 500;

  function handleKeyPress(event: any) {
    window.clearTimeout(timer);
  }

  function handleKeyUp(event: any) {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      console.log(event.target.value);
      setSearchPhrase(event.target.value);
    }, timeoutVal);
  }
  return (
    <Fragment>
      <Box sx={{ backgroundColor: "#f2f2f2", py: 5 }}>
        <Container>
          <Typography variant="h4" component="h1">
            Articles
          </Typography>
          <br />
          <Typography>
            Discover fun reads, interesting facts and how to articles about art,
            framing and more
          </Typography>
          <br />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              border: "2px solid black",
              width: { md: "25rem", xs: "100%" },
              borderRadius: "7px",
              p: "8px 10px",
            }}
          >
            <input
              type="text"
              placeholder="Search topics"
              className={styles.input}
              onKeyDown={handleKeyPress}
              onKeyUp={handleKeyUp}
            />
            <SearchIcon />
          </Box>
        </Container>
      </Box>
      <Container sx={{ mb: 20 }}>
        <BlogTab searchPhrase={searchPhrase} />
      </Container>
    </Fragment>
  );
};

export default Blogs;
